module.exports = __webpack_public_path__ + "img/yum.4c8301e6.png";